import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { completeGoogle } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { nav("/login", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", "/creator");
        completeGoogle(data.user);
        toast.success(`Welcome, ${data.user.name}`);
        nav("/creator", { replace: true, state: { user: data.user } });
      } catch (err) {
        const d = err.response?.data?.detail;
        const msg = typeof d === "string" ? d : "Google sign-in failed";
        setError(msg);
        toast.error(msg);
        setTimeout(() => nav("/login", { replace: true }), 2200);
      }
    };
    run();
  }, [nav, completeGoogle]);

  return (
    <div className="min-h-screen bg-background grain flex items-center justify-center">
      <div className="relative z-10 text-center">
        {error ? (
          <p className="text-red-400 max-w-sm px-6">{error}</p>
        ) : (
          <>
            <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
            <p className="text-muted-foreground mt-4 text-sm uppercase tracking-widest">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
